import React from 'react';
import { Box, Stack, Text } from '@stitch-fix/mode-react';
import {
  type CloudinaryImageFields,
  CloudinaryImageWrapper,
} from '../CloudinaryImageWrapper';
import styles from './styles.module.scss';
import { MODE_MIN_WIDTH } from '../../utils/values/mediaQueries';

export interface FooterImageLinksProps {
  title: string;
  links: {
    caption: string;
    href: string;
    image: CloudinaryImageFields;
  }[];
}

export const FooterImageLinks = ({ title, links }: FooterImageLinksProps) => {
  return (
    <Stack
      hAlign="center"
      maxWidth={69.75}
      mx="auto"
      px={{ sm: 1 }}
      spacing={1.5}
    >
      <Text setting="title-large" align="center">
        {title}
      </Text>
      <Box className={styles.links}>
        {links.map(link => (
          <Box as="a" href={link.href} className={styles.link} key={link.href}>
            <Box className={styles.image}>
              <CloudinaryImageWrapper
                alt={link.image.alt}
                aspectRatio={link.image.aspectRatio}
                sources={{ sm: { w: 112 } }}
                src={link.image.src}
                cloudinaryAsset={link.image.cloudinaryAsset}
                sizes={[{ minWidth: MODE_MIN_WIDTH.sm, staticWidth: 112 }]}
                imageProps={{
                  loading: 'lazy',
                  style: {
                    borderRadius: 8,
                  },
                }}
              />
            </Box>
            <Text setting="title-xsmall">{link.caption}</Text>
          </Box>
        ))}
      </Box>
    </Stack>
  );
};
